export const isNullOrEmptyString = test => {
  return !test || !test.length;
};
